var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c("h4", [_vm._v("Dimensions")])
          ]),
          _vm._v(" "),
          _vm.$v.room.$error
            ? _c("v-flex", { attrs: { xs12: "" } }, [
                !_vm.$v.room.name.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Name")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type !== "Curved Curtain" && !_vm.$v.room.width.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Width")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type !== "Curved Curtain" &&
                !_vm.$v.room.width.between &&
                _vm.type !== "Misc"
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter width between " +
                          _vm._s(_vm.$v.room.width.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.width.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "Curved Curtain" && !_vm.$v.room.widthLeft.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Width Left")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "Curved Curtain" && !_vm.$v.room.widthLeft.between
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter Width Left between " +
                          _vm._s(_vm.$v.room.widthLeft.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.widthLeft.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "Curved Curtain" &&
                _vm.corners === "Two corners" &&
                !_vm.$v.room.widthMiddle.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Width Middle")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "Curved Curtain" &&
                _vm.corners === "Two corners" &&
                !_vm.$v.room.widthMiddle.between
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter width Middle between " +
                          _vm._s(_vm.$v.room.widthMiddle.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.widthMiddle.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "Curved Curtain" &&
                !_vm.$v.room.widthRight.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Width Right")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "Curved Curtain" && !_vm.$v.room.widthRight.between
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter Width Right between " +
                          _vm._s(_vm.$v.room.widthRight.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.widthRight.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.room.drop.required && _vm.type !== "Pelmets"
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Drop")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.room.drop.between &&
                _vm.type != "Misc" &&
                _vm.type !== "Pelmets"
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter drop between " +
                          _vm._s(_vm.$v.room.drop.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.drop.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Name", v: _vm.$v.room.name },
                model: {
                  value: _vm.room.name,
                  callback: function($$v) {
                    _vm.$set(_vm.room, "name", $$v)
                  },
                  expression: "room.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.type !== "3D Shutters" && _vm.type !== "Curved Curtain"
            ? _c(
                "v-flex",
                { attrs: { xs12: "", sm4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Width", v: _vm.$v.room.width },
                    model: {
                      value: _vm.room.width,
                      callback: function($$v) {
                        _vm.$set(_vm.room, "width", $$v)
                      },
                      expression: "room.width"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "Curved Curtain"
            ? _c(
                "v-flex",
                { attrs: { xs12: "", sm4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Width Left", v: _vm.$v.room.widthLeft },
                    model: {
                      value: _vm.room.widthLeft,
                      callback: function($$v) {
                        _vm.$set(_vm.room, "widthLeft", $$v)
                      },
                      expression: "room.widthLeft"
                    }
                  }),
                  _vm._v(" "),
                  _vm.corners === "Two corners"
                    ? _c("v-text-field", {
                        attrs: {
                          label: "Width Middle",
                          v: _vm.$v.room.widthMiddle
                        },
                        model: {
                          value: _vm.room.widthMiddle,
                          callback: function($$v) {
                            _vm.$set(_vm.room, "widthMiddle", $$v)
                          },
                          expression: "room.widthMiddle"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Width Right", v: _vm.$v.room.widthRight },
                    model: {
                      value: _vm.room.widthRight,
                      callback: function($$v) {
                        _vm.$set(_vm.room, "widthRight", $$v)
                      },
                      expression: "room.widthRight"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type !== "Pelmets"
            ? _c(
                "v-flex",
                { attrs: { xs12: "", sm4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Drop", v: _vm.$v.room.drop },
                    model: {
                      value: _vm.room.drop,
                      callback: function($$v) {
                        _vm.$set(_vm.room, "drop", $$v)
                      },
                      expression: "room.drop"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a2384f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2384f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/DimensionSelector.vue
// module id = null
// module chunks = 